// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ContractResponse

import { BillingSanctionLevel, BillingPackageName } from './enums.gen';
import { hydrateContractAdditionalLine, type ContractAdditionalLine, type ContractAdditionalLineApiResponse } from './contractAdditionalLine.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ContractApiResponse = {
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	currency: string;
	frequency: number;
	billingEnabled: boolean;
	nextInvoiceDate: string | null;
	nextInvoiceAdditionalLines: ContractAdditionalLineApiResponse[];
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	sanctionLevel: BillingSanctionLevel;
	sanctionLevelDegradeDate: string | null;
	canUserChangePackage: boolean;
	nextPackage: BillingPackageName;
	currentPackage: BillingPackageName;
	recoveryFee: number;
	recoverAgreedAmount: number;
	totalAmountUnpaid: number;
	cancelAtPeriodEnd: boolean;
	paymentFeePercent: number;
	paymentFeeFixed: number;
	guaranteeFee: number;
	splitPaymentFee: number;
	vatNumber: string | null;
	vatPercent: number;
	legalCompanyIdentifier: string | null;
	companyName: string;
	companyAddress: string;
	city: string | null;
	zipCode: string | null;
	country: string;
	qontoCustomerId: string | null;
	requirePaymentMethod: boolean;
	hasOpenInvoice: boolean;
	hasProcessingPayment: boolean;
};

export type Contract = {
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	currency: string;
	frequency: number;
	billingEnabled: boolean;
	nextInvoiceDate: DateTime | null;
	nextInvoiceAdditionalLines: ContractAdditionalLine[];
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	sanctionLevel: BillingSanctionLevel;
	sanctionLevelDegradeDate: DateTime | null;
	canUserChangePackage: boolean;
	nextPackage: BillingPackageName;
	currentPackage: BillingPackageName;
	recoveryFee: number;
	recoverAgreedAmount: number;
	totalAmountUnpaid: number;
	cancelAtPeriodEnd: boolean;
	paymentFeePercent: number;
	paymentFeeFixed: number;
	guaranteeFee: number;
	splitPaymentFee: number;
	vatNumber: string | null;
	vatPercent: number;
	legalCompanyIdentifier: string | null;
	companyName: string;
	companyAddress: string;
	city: string | null;
	zipCode: string | null;
	country: string;
	qontoCustomerId: string | null;
	requirePaymentMethod: boolean;
	hasOpenInvoice: boolean;
	hasProcessingPayment: boolean;
};

export function hydrateContract(data: ContractApiResponse): Contract {
	return {
		...data,
		nextInvoiceDate: DateTimefromISO(data.nextInvoiceDate),
		nextInvoiceAdditionalLines: data.nextInvoiceAdditionalLines.map(hydrateContractAdditionalLine),
		sanctionLevelDegradeDate: DateTimefromISO(data.sanctionLevelDegradeDate),
	};
}